export default "__VITE_ASSET__CW61OjSW__"